<datalist id="zip-codes">
    @for (address of zipCodeList; track address) {
    <option (click)="selectZipCode(address)" [value]="address.zipcode">
        {{address.zipcode}}, {{address.city}}</option>
    }
</datalist>

<div class="card">
    <div class="card-header">
        <button class="btn btn-light btn-xs" (click)="expanded = !expanded">
            @if (expanded) {
            <span class="dripicons-chevron-up"></span>
            }
            @if (!expanded) {
            <span class="dripicons-chevron-down"></span>
            }
        </button>
        {{ words[language][ 'addresses' ] }}
        <span class="badge badge-info">{{addressList ?
            addressList.length : ''}}</span>
        <!-- <div [ngClass]="{ 'd-none': address.primaryAddress !== 1 }" *ngFor="let address of addressList; let i = index">
<small class="primary-add" *ngIf="selected.address != 'none'">{{ address.addressType.type }}: {{ selected.address }},
{{ selected.address2 }}
{{ selected.city }}, {{ selected.state }}
{{ selected.zipCode }}</small>
</div> -->
        <!-- Add New Address Button -->
        <!-- <div class="d-flex ml-auto"> -->
        @if (!isFlat) {
        <button type="button" class="btn btn-sm btn-primary float-right" data-toggle="modal" data-target="#addNewAddressModal" (click)="cleanFields(true)" title="Add" [disabled]="contactId == 0">Add</button>
        }
        <!-- </div> -->
    </div>
    <!-- Addresses -->
    @if (expanded) {
    <div>
        <div class="card-body">
            <div class="row text-dark m-1">
                <!-- Create New Address from Sale -->
                @if (isFlat && !addressUpdate) {
                <section>
                    <form [formGroup]="information" class="d-flex p-1 justify-content-between row mx-0 w-100">
                        <!-- type input-->
                        <div class="form-group col-md-6 col-sm-12 m-0 p-1">
                            <label for="addressTypeId">{{ words[language][ 'type' ] }}</label>
                            <select class="custom-select custom-select-sm" id="addressTypeId" formControlName="addressTypeId">
                                @for (addyType of types; track addyType.id) {
                                <option [value]="addyType.id">
                                    {{ addyType.type }}
                                </option>
                                }
                            </select>
                        </div>
                        <!-- status input -->
                        @if (isIndividual) {
                        <div class="form-group col-md-6 col-sm-12 m-0 p-1">
                            <label for="status">{{ words[language][ 'rentOwn' ] }}</label>
                            <select class="custom-select custom-select-sm" id="statusId" formControlName="status">
                                @for (rent of rentOwn; track rent) {
                                <option [value]="rent">
                                    {{ rent }}
                                </option>
                                }
                            </select>
                        </div>
                        }
                        <!-- adress input -->
                        <div class="form-group col-md-12 col-sm-12">
                            <label for="address">{{ words[language][ 'address' ] }}</label>
                            <input class="form-control" type="text" id="address" formControlName="address" autocomplete="off" />
                            @if (address.invalid && address.dirty) {
                            <span class="text-danger">{{ words[language][ 'invalidAddress' ] }}</span>
                            }
                        </div>
                        <!--  adress 2 input -->
                        <div class="form-group col-md-12 col-sm-12">
                            <label for="address2">{{ words[language][ 'address' ] }} 2</label>
                            <input class="form-control" type="text" id="address2" formControlName="address2" autocomplete="off" />
                            @if (address2.invalid && address2.dirty) {
                            <span class="text-danger">{{ words[language][ 'invalidAddress' ] }}</span>
                            }
                        </div>
                        <!--  Zip Code input -->
                        <div class="form-group col-md-4 col-sm-12 m-0 p-1">
                            <label for="zipCode">{{ words[language][ 'zipcode' ] }}</label>
                            <div class="position-relative hover-list">
                                <!-- input -->
                                <input class="form-control" type="search" id="zipCode" formControlName="zipCode" autocomplete="off" (keyup)="searchZipCode()" list="zip-codes" />
                            </div>
                            @if (zipCode.invalid && zipCode.dirty) {
                            <span class="text-danger">{{ words[language][ 'invalidZipcode' ] }}</span>
                            }
                        </div>
                        <!--  City input -->
                        <div class="form-group col-md-4 col-sm-12 m-0 p-1">
                            <label>{{ words[language][ 'city' ] }}</label>
                            <input class="form-control" type="text" id="city" formControlName="city" autocomplete="off" readonly />
                        </div>
                        <!--  State input -->
                        <div class="form-group col-md-4 col-sm-12 m-0 p-1">
                            <label>{{ words[language][ 'state' ] }}</label>
                            <input class="form-control" type="text" id="state" formControlName="state" autocomplete="off" readonly />
                        </div>
                        <!--  County input -->
                        <div class="form-group col-md-6 col-sm-12 m-0 p-1">
                            <label>{{ words[language][ 'county' ] }}</label>
                            <input class="form-control" type="text" id="county" formControlName="county" autocomplete="off" readonly />
                        </div>
                        <!--  Country input -->
                        <div class="form-group col-md-6 col-sm-12 m-0 p-1">
                            <label>{{ words[language][ 'country' ] }}</label>
                            <input class="form-control" type="text" id="country" formControlName="country" autocomplete="off" readonly />
                        </div>
                        <!-- Start Date input -->
                        <div class="form-group col-md-6 col-sm-12 m-0 p-1">
                            <label for="startDate"> {{ words[language][ 'startDate' ] }}</label>
                            <input class="form-control" type="date" max="3000-12-31" id="startDate" formControlName="startDate" />
                            @if (startDate.invalid && startDate.dirty) {
                            <span class="text-danger">{{ words[language][ 'invalidStartDate' ] }}</span>
                            }
                        </div>
                        <!--  end Date input -->
                        <div class="form-group col-md-6 col-sm-12 m-0 p-1">
                            <label for="endDate">{{ words[language][ 'endDate' ] }}</label>
                            <input class="form-control" type="date" max="3000-12-31" id="endDate" formControlName="endDate" />
                            @if (endDate.invalid && endDate.dirty) {
                            <span class="text-danger">{{ words[language][ 'invalidEndDate' ] }}</span>
                            }
                        </div>
                        <!--  -->
                        <div class="col-md-12 d-flex justify-content-end px-3 mt-2">
                            <!-- save button -->
                            <button class="btn btn-success mr-2" id="btn-save-addresses" [disabled]="!information.valid || loading" (click)="save(true)">
                                @if (loading) {
                                <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                                }
                                {{ words[language][ 'add' ] }}
                            </button>
                        </div>
                    </form>
                </section>
                }
                <!-- Update Existing Address from Sale -->
                @if (isFlat && addressUpdate) {
                <section>
                    <h4 class="px-3" id="standard-modalLabel">{{ words[language][ 'updateAddress' ] }}</h4>
                    <form [formGroup]="information" class="d-flex p-2 justify-content-between row mx-0 w-100">
                        <!-- type input-->
                        <div class="form-group col-md-6 col-sm-12">
                            <label for="addressTypeId">{{ words[language][ 'type' ] }}</label>
                            <select class="custom-select custom-select-sm mb-1" id="addressTypeId" formControlName="addressTypeId">
                                @for (addyType of types; track addyType.id) {
                                <option [value]="addyType.id">
                                    {{ addyType.type }}
                                </option>
                                }
                            </select>
                        </div>
                        <!-- status input -->
                        @if (isIndividual) {
                        <div class="form-group col-md-6 col-sm-12">
                            <label for="status">{{ words[language][ 'rentOwn' ] }}</label>
                            <select class="custom-select custom-select-sm mb-1" id="statusId" formControlName="status">
                                @for (rent of rentOwn; track rent) {
                                <option [value]="rent">
                                    {{ rent }}
                                </option>
                                }
                            </select>
                        </div>
                        }
                        <!-- adress input -->
                        <div class="form-group col-md-12 col-sm-12">
                            <label for="address">{{ words[language][ 'address' ] }}</label>
                            <input class="form-control" type="text" id="address" formControlName="address" autocomplete="address-level1" />
                            @if (address.invalid && address.dirty) {
                            <span class="text-danger">{{ words[language][ 'invalidAddress'
                                ]
                                }}</span>
                            }
                        </div>
                        <!--  adress 2 input -->
                        <div class="form-group col-md-12 col-sm-12">
                            <label for="address2">{{ words[language][ 'address' ] }} 2</label>
                            <input class="form-control" type="text" id="address2" formControlName="address2" autocomplete="address-line1" />
                            @if (address2.invalid && address2.dirty) {
                            <span class="text-danger">{{ words[language][
                                'invalidAddress'
                                ] }}</span>
                            }
                        </div>
                        <!--  Zip Code input -->
                        <div class="form-group col-md-4 col-sm-12">
                            <label for="zipCode">{{ words[language][ 'zipcode' ] }}</label>
                            <div class="position-relative hover-list">
                                <!-- input -->
                                <input class="form-control" type="search" id="zipCode" formControlName="zipCode" autocomplete="off" (keyup)="searchZipCode()" list="zip-codes" />
                            </div>
                            @if (zipCode.invalid && zipCode.dirty) {
                            <span class="text-danger">{{ words[language][ 'invalidZipcode'
                                ]
                                }}</span>
                            }
                        </div>
                        <!--  City input -->
                        <div class="form-group col-md-4 col-sm-12">
                            <label for="zipCode">{{ words[language][ 'city' ] }}</label>
                            <input class="form-control" type="text" id="city" formControlName="city" autocomplete="off" readonly />
                        </div>
                        <!--  State input -->
                        <div class="form-group col-md-4 col-sm-12">
                            <label for="zipCode">{{ words[language][ 'state' ] }}</label>
                            <input class="form-control" type="text" id="state" formControlName="state" autocomplete="off" readonly />
                        </div>
                        <!--  County input -->
                        <div class="form-group col-md-6 col-sm-12">
                            <label for="zipCode">{{ words[language][ 'county' ] }}</label>
                            <input class="form-control" type="text" id="county" formControlName="county" autocomplete="off" readonly />
                        </div>
                        <!--  Country input -->
                        <div class="form-group col-md-6 col-sm-12">
                            <label for="zipCode">{{ words[language][ 'country' ] }}</label>
                            <input class="form-control" type="text" id="country" formControlName="country" autocomplete="off" readonly />
                        </div>
                        <!-- Start Date input -->
                        <div class="form-group col-md-6 col-sm-12">
                            <label for="startDate">{{ words[language][ 'startDate' ] }}</label>
                            <input class="form-control" type="date" max="3000-12-31" id="startDate" formControlName="startDate" />
                            @if (startDate.invalid && startDate.dirty) {
                            <span class="text-danger">{{ words[language][
                                'invalidStartDate' ] }}</span>
                            }
                        </div>
                        <!--  end Date input -->
                        <div class="form-group col-md-6 col-sm-12">
                            <label for="endDate">{{ words[language][ 'endDate' ] }}</label>
                            <input class="form-control" type="date" max="3000-12-31" id="endDate" formControlName="endDate" />
                            @if (endDate.invalid && endDate.dirty) {
                            <span class="text-danger">{{ words[language][ 'invalidEndDate'
                                ]
                                }}</span>
                            }
                        </div>
                        <!--  -->
                        <div class="col-md-12 d-flex justify-content-end px-3 mt-2">
                            <!-- save button -->
                            <button class="btn btn-success mr-2" [disabled]="information.invalid || loading" (click)="modifyAddress()">
                                @if (loading) {
                                <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                                }
                                Update
                            </button>
                            <!-- cancel button -->
                            <button class="btn btn-light" id="btn-close-addresses-update" (click)="cleanFields(true)" data-dismiss="modal" data-dismiss="modal">
                                {{ words[language][ 'cancel' ] }}
                            </button>
                        </div>
                    </form>
                </section>
                }
                <!-- List of Addresses -->
                @for (address of addressList; track address; let i = $index) {
                <div class="col-md-12 col-sm-12" [ngClass]="{'col-md-6': isFlat}" [ngClass]="{'col-md-6': isFlat}">
                    <div class="card ribbon-box border">
                        @if (address.primaryAddress) {
                        <div class="ribbon-two ribbon-two-primary">
                            <span>{{ words[language][ 'default' ] }}</span>
                        </div>
                        }
                        <div class="card-header">
                            <div class="font-weight-bold text-center">
                                {{ address.addressType.type }}
                            </div>
                        </div>
                        <div class="card-body">
                            <table class="table">
                                <tbody>
                                    <td>
                                        <tr>{{ address.address }}, {{ address.address2 }}</tr>
                                        <tr>{{ address.city }}, {{ address.state }} {{ address.zipCode }}</tr>
                                        @if (address.startDate) {
                                        <tr>Start Date: {{ address.startDate | date: "shortDate" }}</tr>
                                        }
                                        @if (address.endDate) {
                                        <tr>End Date: {{ address.endDate | date: "shortDate" }}</tr>
                                        }
                                        @if (address.endDate && address.startDate) {
                                        <tr>Duration (Days):
                                            {{calculateDiff(address.startDate,address.endDate)}}</tr>
                                        }
                                        @if (isIndividual) {
                                        <tr>Living Status: {{ address.status }}</tr>
                                        }
                                        <tr></tr>
                                    </td>
                                </tbody>
                            </table>
                        </div>
                        <div class="card-footer text-center">
                            <button class="btn btn-sm text-dark" title="Set as Default" [name]="address.id" [id]="address" (click)="selectDefault(address)" [ngClass]="{ 'd-none': address.primaryAddress}">
                                Set as Default
                            </button>
                            <button class="btn btn-sm text-dark" title="Map Me!" (click)="
openLocation(address.address, address.county, address.state)
">
                                Locate
                            </button>
                            <!-- ? no flat -->
                            <!-- todo:edit -->
                            @if (!isFlat) {
                            <button class="btn btn-sm text-dark" data-toggle="modal" title="Edit" data-target="#updateAddressModal" (click)="selectAddressUpdate(address)">
                                Edit
                            </button>
                            }
                            <!-- ! delete -->
                            @if (!isFlat) {
                            <button class="btn btn-sm text-danger" data-toggle="modal" title="Delete" data-target="#deleteAddressModal" (click)="selectAddress(address)">
                                Delete
                            </button>
                            }
                            <!-- ? flat -->
                            <!-- todo edit -->
                            @if (isFlat) {
                            <button class="btn btn-sm text-dark" title="Edit" (click)="selectAddressUpdate(address)">
                                Edit
                            </button>
                            }
                            <!-- !delete -->
                            @if (isFlat) {
                            <button class="btn btn-sm text-danger" title="Delete" (click)="questDelete(address)">
                                Delete
                            </button>
                            }
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
    </div>
    }
</div>
<!-- MODALS -->
<!-- Add Address Modal -->
<div id="addNewAddressModal" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="standard-modalLabel">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header bg-light">
                <h4 class="modal-title" id="standard-modalLabel">{{ words[language][ 'addAddress' ] }}</h4>
                <button type="button" class="close" data-dismiss="modal">
                    ×
                </button>
            </div>
            <div class="modal-body">
                <!-- body -->
                <form [formGroup]="information" class="row">
                    <!-- type input-->
                    <div class="form-group col-md-6 col-sm-12">
                        <label for="addressTypeId">{{ words[language][ 'type' ] }}</label>
                        <select class="custom-select custom-select-sm mb-1" id="addressTypeId" formControlName="addressTypeId">
                            @for (addyType of types; track addyType.id) {
                                <option [value]="addyType.id">{{ words[language][ addyType.type.toLowerCase() ] }}</option>
                            }
                        </select>
                    </div>
                    <!-- status input -->
                    @if (isIndividual) {
                    <div class="form-group col-md-6 col-sm-12">
                        <label for="status">{{ words[language][ 'rentOwn' ] }}</label>
                        <select class="custom-select custom-select-sm mb-1" id="statusId" formControlName="status">
                            @for (rent of rentOwn; track rent) {
                                <option [value]="rent">{{rent}}</option>
                            }
                        </select>
                    </div>
                    }
                    <!-- adress input -->
                    <div class="form-group col-md-12 col-sm-12 my-1">
                        <label for="address">{{ words[language][ 'address' ] }}</label>
                        <input class="form-control" type="text" id="address" formControlName="address" autocomplete="off" />
                        @if (address.invalid && address.dirty) {
                        <span class="text-danger">{{ words[language][ 'invalidAddress' ]
                            }}</span>
                        }
                    </div>
                    <!--  adress 2 input -->
                    <div class="form-group col-md-12 col-sm-12 my-1">
                        <label for="address2">{{ words[language][ 'address' ] }} 2</label>
                        <input class="form-control" type="text" id="address2" formControlName="address2" autocomplete="off" />
                        @if (address2.invalid && address2.dirty) {
                        <span class="text-danger">{{ words[language][ 'invalidAddress'
                            ] }}</span>
                        }
                    </div>
                    <!--  Zip Code input -->
                    <div class="form-group col-md-4 col-sm-12">
                        <label for="zipCode">{{ words[language][ 'zipcode' ] }}</label>
                        <div class="position-relative hover-list">
                            <!-- input -->
                            <input class="form-control" type="search" id="zipCode" formControlName="zipCode" autocomplete="off" (keyup)="searchZipCode()" list="zip-codes" />
                        </div>

                        @if (zipCode.invalid && zipCode.dirty) {
                        <span class="text-danger">{{ words[language][ 'invalidZipcode' ]
                            }}</span>
                        }
                    </div>
                    <!--  City input -->
                    <div class="form-group col-md-4 col-sm-12">
                        <label>{{ words[language][ 'city' ] }}</label>
                        <input class="form-control" type="text" id="city" formControlName="city" autocomplete="off" readonly />
                    </div>
                    <!--  State input -->
                    <div class="form-group col-md-4 col-sm-12">
                        <label>{{ words[language][ 'state' ] }}</label>
                        <input class="form-control" type="text" id="state" formControlName="state" autocomplete="off" readonly />
                    </div>
                    <!--  County input -->
                    <div class="form-group col-md-6 col-sm-12">
                        <label>{{ words[language][ 'county' ] }}</label>
                        <input class="form-control" type="text" id="county" formControlName="county" autocomplete="off" readonly />
                    </div>
                    <!--  Country input -->
                    <div class="form-group col-md-6 col-sm-12">
                        <label>{{ words[language][ 'country' ] }}</label>
                        <input class="form-control" type="text" id="country" formControlName="country" autocomplete="off" readonly />
                    </div>
                    <!-- Start Date input -->
                    <div class="form-group col-md-6 col-sm-12">
                        <label for="startDate"> {{ words[language][ 'startDate' ] }}</label>
                        <input class="form-control" type="date" max="3000-12-31" id="startDate" formControlName="startDate" />
                        @if (startDate.invalid && startDate.dirty) {
                        <span class="text-danger">{{ words[language][
                            'invalidStartDate' ] }}</span>
                        }
                    </div>
                    <!--  end Date input -->
                    <div class="form-group col-md-6 col-sm-12">
                        <label for="endDate">{{ words[language][ 'endDate' ] }}</label>
                        <input class="form-control" type="date" max="3000-12-31" id="endDate" formControlName="endDate" />
                        @if (endDate.invalid && endDate.dirty) {
                        <span class="text-danger">{{ words[language][ 'invalidEndDate' ]
                            }}</span>
                        }
                    </div>
                </form>
                <div class="modal-footer">
                    <!-- <div class="col-md-12 d-flex justify-content-end"> -->
                    <!-- add button -->
                    <!-- <button class="btn btn-success mr-2" id="btn-add-addresses" (click)="save(false)"
[disabled]="information.invalid || loading">
<span class="spinner-grow spinner-grow-sm mr-1" role="status" *ngIf="loading"></span>
{{ words[language][ 'add' ] }}
</button> -->
                    <button class="btn btn-success mr-2" id="btn-add-addresses" (click)="add(information.value)" [disabled]="information.invalid || loading">
                        @if (loading) {
                        <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                        }Add Another
                    </button>
                    <!-- save button -->
                    <button class="btn btn-success mr-2" id="btn-save-addresses" [disabled]="information.invalid || loading" (click)="save(true)" [class.d-none]="isFlat">
                        @if (loading) {
                        <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                        }
                        {{ words[language][ 'save' ] }}
                    </button>
                    <!-- cancel button -->
                    <button class="btn btn-light" id="btn-cancel-addresses" data-dismiss="modal" data-dismiss="modal">
                        {{ words[language][ 'cancel' ] }}
                    </button>
                    <!-- </div> -->
                </div>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

<!-- Delete Modal -->
<div id="deleteAddressModal" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
                <span class="dripicons-cross text-danger h1"></span>
                <h4 class="text-danger w-100 text-center">{{ words[language][ 'delete' ] }}</h4>
                <span class="text-muted my-3 text-center">{{ words[language][ 'deleteAddress' ] }}</span>

                <button class="btn btn-danger mt-2" (click)="delete()" [disabled]="loading">
                    @if (loading) {
                    <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                    }
                    {{ words[language][ 'yes' ] }}
                </button>
                <button type="button" class="btn btn-secondary mt-2 ml-2" data-dismiss="modal" id="close-delete-modal">
                    No
                </button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

<!-- Update Modal -->
<div id="updateAddressModal" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="standard-modalLabel">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header bg-light">
                <h4 class="modal-title" id="standard-modalLabel">{{ words[language][ 'updateAddress' ] }}</h4>
                <button type="button" class="close" data-dismiss="modal">
                    ×
                </button>
            </div>
            <div class="modal-body">
                <!-- body -->
                <form [formGroup]="information" class="row">
                    <!-- type input-->
                    <div class="form-group col-md-6 col-sm-12">
                        <label for="addressTypeId">{{ words[language][ 'type' ] }}</label>
                        <select class="custom-select custom-select-sm mb-1" id="addressTypeId" formControlName="addressTypeId">
                            @for (addyType of types; track addyType.id) {
                            <option [value]="addyType.id">{{ words[language][ addyType.type.toLowerCase() ] }}</option>
                            }
                        </select>
                    </div>
                    <!-- status input -->
                    @if (isIndividual) {
                    <div class="form-group col-md-6 col-sm-12">
                        <label for="status">{{ words[language][ 'rentOwn' ] }}</label>
                        <select class="custom-select custom-select-sm mb-1" id="statusId" formControlName="status">
                            @for (rent of rentOwn; track rent) {
                                <option [value]="rent.toLowerCase()">{{ rent }}</option>
                            }
                        </select>
                    </div>
                    }
                    <!-- adress input -->
                    <div class="form-group col-md-12 col-sm-12">
                        <label for="address">{{ words[language][ 'address' ] }}</label>
                        <input class="form-control" type="text" id="address" formControlName="address" autocomplete="address-level1" />
                        @if (address.invalid && address.dirty) {
                        <span class="text-danger">{{ words[language][ 'invalidAddress' ]
                            }}</span>
                        }
                    </div>
                    <!--  adress 2 input -->
                    <div class="form-group col-md-12 col-sm-12">
                        <label for="address2">{{ words[language][ 'address' ] }} 2</label>
                        <input class="form-control" type="text" id="address2" formControlName="address2" autocomplete="address-line1" />
                        @if (address2.invalid && address2.dirty) {
                        <span class="text-danger">{{ words[language][ 'invalidAddress'
                            ] }}</span>
                        }
                    </div>
                    <!--  Zip Code input -->
                    <div class="form-group col-md-4 col-sm-12">
                        <label for="zipCode">{{ words[language][ 'zipcode' ] }}</label>
                        <div class="position-relative hover-list">
                            <!-- input -->
                            <input class="form-control" type="search" id="zipCode" formControlName="zipCode" autocomplete="off" (keyup)="searchZipCode()" />
                        </div>

                        @if (zipCode.invalid && zipCode.dirty) {
                        <span class="text-danger">{{ words[language][ 'invalidZipcode' ]
                            }}</span>
                        }
                    </div>
                    <!--  City input -->
                    <div class="form-group col-md-4 col-sm-12">
                        <label for="zipCode">{{ words[language][ 'city' ] }}</label>
                        <input class="form-control" type="text" id="city" formControlName="city" autocomplete="off" readonly />
                    </div>
                    <!--  State input -->
                    <div class="form-group col-md-4 col-sm-12">
                        <label for="zipCode">{{ words[language][ 'state' ] }}</label>
                        <input class="form-control" type="text" id="state" formControlName="state" autocomplete="off" readonly />
                    </div>
                    <!--  County input -->
                    <div class="form-group col-md-6 col-sm-12">
                        <label for="zipCode">{{ words[language][ 'county' ] }}</label>
                        <input class="form-control" type="text" id="county" formControlName="county" autocomplete="off" readonly />
                    </div>
                    <!--  Country input -->
                    <div class="form-group col-md-6 col-sm-12">
                        <label for="zipCode">{{ words[language][ 'country' ] }}</label>
                        <input class="form-control" type="text" id="country" formControlName="country" autocomplete="off" readonly />
                    </div>
                    <!-- Start Date input -->
                    <div class="form-group col-md-6 col-sm-12">
                        <label for="startDate">{{ words[language][ 'startDate' ] }}</label>
                        <input class="form-control" type="date" max="3000-12-31" id="startDate" formControlName="startDate" />
                        @if (startDate.invalid && startDate.dirty) {
                        <span class="text-danger">{{ words[language][
                            'invalidStartDate' ] }}</span>
                        }
                    </div>
                    <!--  end Date input -->
                    <div class="form-group col-md-6 col-sm-12">
                        <label for="endDate">{{ words[language][ 'endDate' ] }}</label>
                        <input class="form-control" type="date" max="3000-12-31" id="endDate" formControlName="endDate" />
                        @if (endDate.invalid && endDate.dirty) {
                        <span class="text-danger">{{ words[language][ 'invalidEndDate' ]
                            }}</span>
                        }
                    </div>
                </form>
                <div class="modal-footer">
                    <!-- <div class="col-md-12 d-flex justify-content-end px-3 mt-2"> -->
                    <!-- save button -->
                    <button class="btn btn-success mr-2" [disabled]="information.invalid || loading" (click)="modifyAddress()">
                        @if (loading) {
                        <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                        }Update
                    </button>
                    <!-- cancel button -->
                    <button class="btn btn-light" id="btn-close-addresses-update" data-dismiss="modal" data-dismiss="modal">
                        {{ words[language][ 'cancel' ] }}
                    </button>
                    <!-- </div> -->
                </div>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->